<template>
    <div class="sv-wrap">
        <div class="outer"
            :style="{backgroundColor:bg}"
        >
            <div ref="spriteCon" class="view" :style="spriteName"></div>
            <canvas ref="imageCanvas" width="800" height="528"></canvas>
        </div>
        <nav :class="{'open':nav_open}">
            <svg class="closeControl" @click="toggleNav" viewBox="0 0 25 25" width="25" height="25"><path stroke-width="3" fill="none" d="M 10, 2 L15,13 10,23" /></svg>
            <div class="slice_scroller">
                <img :src="planName" alt="slice" />
                <div class="slices"
                    @mousewheel.stop.prevent="mousewheelMoved"
                    @click.prevent="sliceTouch" 
                    :style="{top:SliceObj.planOffset+'px',backgroundSize:'100% '+SliceObj.planSpace+'px',height:SliceObj.planSpace*SliceObj.planCnt+'px'}"
                ></div>
                <svg :style="{top:SliceObj.planSpace*(s_count-1-current_slice)+SliceObj.planOffset+'px'}"
                    class="indicate"><path d="M0,0 H256"/></svg>
            </div>
            <div class="sibs">
                <p><input type="checkbox" :id="plan" class="switch"><label :for="plan" @click="labelSlice">Show Labels</label></p>
                <button v-for="(ob,ix) in SliceObj.modes" v-bind:key="ix"
                    :data-id="ix" @click="setMode"
                    :class="{'selected':current_mode==ix}"
                >{{ob.name}}</button>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    data: function(){
        return {
            SliceObj:{},
            lastError: undefined,
            current_mode: 0,
            current_slice: 0,
            nav_open: false,
            bg: "white",
            ctx: undefined, // the 2d context for label canvas
            s_count: 5,
            slice_thickness: undefined,
            spriteName: undefined
        }
    },
    props: ['title','plan','sprite','w'],
    computed: {
        planName: function(){
            return `./img/${this.plan}_plan.png`;
        }
    },
    methods: {
        sliceTouch: function(e){
            let slice = this.s_count - Math.round((e.layerY+(this.slice_thickness>>1))/this.slice_thickness);
            this.setSlice(slice);
        },
        toggleNav: function(){
            this.nav_open = ! this.nav_open;
        },
        setSprite: function(){
            let m = this.SliceObj.modes[this.current_mode];
            let len = m.images.length;
            this.spriteName = `background-image: url(.${m.sprite}); background-size: ${512*len}px 512px;`;
        },
        mousewheelMoved: function(e){
            let delta = Math.max(-1, Math.min(1, e.wheelDelta));
            if (delta>0)
                this.nextSlice();
            if (delta<0)
                this.prevSlice();
        },
        setSlice: function(n){
            this.current_slice = n;
            if (this.current_slice >= this.s_count)
                this.current_slice = 0;
            this.labelSlice();
            this.$nextTick(()=>this.$refs.spriteCon.style.backgroundPosition = this.current_slice*-512+"px 0");
        },
        nextSlice: function(){
            this.current_slice++;
            if (this.current_slice >= this.s_count)
                this.current_slice = 0;
            this.labelSlice();
            this.$nextTick(()=>this.$refs.spriteCon.style.backgroundPosition = this.current_slice*-512+"px 0");
        },
        prevSlice: function(){
            this.current_slice--;
            if (this.current_slice < 0)
                this.current_slice = this.s_count - 1;
            this.labelSlice();
            this.$nextTick(()=>this.$refs.spriteCon.style.backgroundPosition = this.current_slice*-512+"px 0");
        },
        setMode: function(e){
            if (e)
                this.current_mode = e.target.dataset.id;
            let m = this.SliceObj.modes[this.current_mode];
            let len = m.images.length;
            this.s_count = len;
            this.slice_thickness = this.SliceObj.planSpace;
            this.setSprite();
            this.bg = m.bgcolour;
            this.labelSlice();
        },
        labelSlice: function (e) {
            // get labels and and draw them on canvas
            let ctx = this.ctx;
            let cpar = ctx.canvas.parentElement;
            let bcr = cpar&&cpar.getBoundingClientRect()||{height:528,width:800};
            let boxheight = bcr.height;
            ctx.clearRect(0, 0, bcr.width, boxheight);
            let mode = this.SliceObj.modes[this.current_mode];
            let labels = mode.images[this.current_slice].labels;
            ctx.fillStyle = "silver";
            if (labels.length==0)
                ctx.fillText("Slice image/labels not available", 30, 30);
            let shState = document.getElementById(this.plan).checked;
            if (e)
                shState = ! shState; // reverse state if called by vue click event handler on switch label
            if (!shState)
                return;
            ctx.strokeStyle = "#00877c";
            ctx.lineWidth = 2;
            let imageWidthDiv2 = mode.width / 2;
            ctx.beginPath();
            let skew = mode.images[this.current_slice].skew;
            let labs = new Array;
            let scale = 256 / imageWidthDiv2;
            for (var i = 0; i < labels.length; i++) {
                // get x/y point for label and calculate angle relative to center of 256x256
                var ll = labels[i].split(';');
                if (ll.length >= 3) {
                    var lab = new Object();
                    lab.x = parseFloat(ll[1]);
                    lab.y = parseFloat(ll[2]);
                    lab.text = ll[0];
                    lab.w = ctx.measureText(lab.text).width;
                    var deltax = lab.x - (imageWidthDiv2 + skew);
                    var deltay = lab.y - (imageWidthDiv2 + skew);
                    lab.angle = (Math.atan2(deltax, deltay - 0.000001) + Math.PI);
                    if (ll.length >= 5)
                        lab.angle += parseFloat(ll[4]);
                    // normalise to unit circle
                    var nx = Math.abs(Math.sin(lab.angle - Math.PI));
                    var ny = Math.abs(Math.cos(lab.angle - Math.PI));
                    // adjust length of line so it is longest in the corners
                    var dnx = Math.min(nx, ny);
                    lab.dist = 210 + dnx * 90;
                    if (ll.length >= 4)
                        lab.dist += parseInt(ll[3]);
                    labs.push(lab);
                }
            } // got all label data
            var asp = 1.4; // aspect ratio
            let fa = Math.PI; // fix angle, needs 180 rotate
            for (i = 0; i < labs.length; i++) {
                lab = labs[i];
                var yy = lab.dist;
                var mang = lab.angle;
                var x0 = Math.sin(mang + fa) * (asp * yy) + (bcr.width/2);
                var y0 = Math.cos(mang+ fa) * yy + boxheight / 2;
                var q = parseInt((mang + Math.PI / 2) / (Math.PI / 2) - 0.5) % 4;
                var hw = (lab.w + 8) / 2;
                var hh = 8; // halfheight of textbox
                switch (q) {
                    case 0://top left
                        y0 += hh;
                        break;
                    case 3://top right
                        x0 -= hw;
                        break;
                    case 2://bottom right
                        y0 -= hh;
                        break;
                    case 1://bottom left
                        x0 += hw;
                        break;
                }
                var x1 = lab.x * scale + 144;
                var y1 = lab.y * scale + 8;
                ctx.moveTo(x0, y0 + hh + 1);
                ctx.lineTo(x1, y1);
                ctx.arc(x1, y1, 1.5, 0, Math.PI * 2, false);
            }
            ctx.stroke();
            for (i = 0; i < labs.length; i++) {
                lab = labs[i];
                yy = lab.dist;
                mang = lab.angle;
                x0 = Math.sin(mang + fa) * (asp * yy) + (bcr.width/2);
                y0 = Math.cos(mang + fa) * yy + boxheight / 2;
                var tw = lab.w + 8;
                var tx = x0 - tw / 2;
                var ty = y0;
                ctx.lineWidth = 1;
                ctx.strokeRect(tx, ty + 1, tw, hh + hh);
                ctx.fillStyle = (this.bg == "white") ? "black" : "#00FFFF";
                ctx.fillText(lab.text, tx + 4, ty+16);
            }
        }
    },
    mounted: async function(){
        this.ctx = this.$refs.imageCanvas.getContext("2d");
        this.ctx.font = "13px Arial";
        this.ctx.textBaseline = "bottom";
        try {
            let response = await fetch(`./json/${this.plan}.json`);
            this.SliceObj = await response.json();
            this.setMode();
        } catch(e){
            this.lastError = e;
        }
    }
}
</script>
<style>
.sv-wrap>nav {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    transition: clip-path 200ms ease;
}
.sv-wrap>nav.open>.closeControl {
    transform: rotate(180deg);
}
.sv-wrap>nav>.closeControl {
    height: 0;
    transition: 200ms ease;
    transition-property: height, transform;
}
nav>.slice_scroller>img {
    opacity:1;
    transition: opacity 200ms ease;
}
@media (max-width: 1312px){
.sv-wrap>nav>.closeControl {
    height: 24px;
}
.sv-wrap>nav {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(255,255,255,0.9);
    clip-path: polygon(0px 0px, 30px 0px, 30px 280px, 0px 280px);
}
.sv-wrap>nav.open {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
}
nav>.slice_scroller>img {
    opacity:0;
}
nav.open>.slice_scroller>img {
    opacity:1;
}
.sv-wrap>.outer{
    border-left: 32px solid var(--color-light-2);
}
}
button:not(.selected) {
    opacity: 0.75;
}
svg.indicate {
    stroke: orange;
    stroke-width: 6;
    stroke-linecap: round;
    position: absolute;
    left: calc(50% - 128px);
    height: 6px;
    pointer-events: none;
}
.slices {
    position: absolute;
    width: 256px;
    top: 120px;
    left: calc(50% - 128px);
    background-color: rgba(0,255,0,0.125);
    background-image: linear-gradient(black, black 1px, transparent 2px);
}
.slice_scroller {
    text-align: center;
    position: relative;
}
.slice_scroller::before {
    content: "Slice Scroller";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    font-size: 1.2rem;
    font-weight: bold;
    padding: 0 0 0.125em 0;
    pointer-events: none;
    background: linear-gradient(rgba(255,255,255,0.75),rgba(255,255,255,0.75),rgba(255,255,255,0));
}
.sv-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    position: relative;
}
.sv-wrap>.outer {
    height: 528px;
    width: 800px;
    position: relative;
}
.outer {
    margin: 0 1.5em 0 0;
}
.outer>canvas {
    position: absolute;
    left:0;
    top:0;
}
.view {
    width: 512px;
    height: 512px;
    margin: auto;
}
.sibs {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>